"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadObjectAsJson = exports.createImage = void 0;
function createImage(src) {
    return new Promise((resolve, reject) => {
        var img = new Image(); // Create new img element
        img.addEventListener("load", function () {
            resolve(img);
        }, false);
        img.src = src; // Set source path
    });
}
exports.createImage = createImage;
// https://stackoverflow.com/questions/19721439/download-json-object-as-a-file-from-browser
function downloadObjectAsJson(exportObj, exportName) {
    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
    var downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", exportName + ".json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
}
exports.downloadObjectAsJson = downloadObjectAsJson;
//# sourceMappingURL=FileUtils.js.map